import firebase from "firebase/app";
import "firebase/auth";

export default async (to, from, next) => {
  let requiresAuth = to.matched.some(
    record => record.meta.requiresAuth !== false
  );
  let requiresGuest = to.matched.some(record => record.meta.requiresGuest);
  const currentUser = firebase.auth().currentUser;

  if (requiresAuth && !currentUser) {
    return next({ name: "Sign In" });
  } else if (requiresGuest && currentUser) {
    return next("/");
  }
  return next();
};
